import React__default from 'react';
import styled from 'styled-components';
import { themeGet } from '../../utils/theme-get.js';
import Combobox from '../Combobox/Combobox.js';
import Box from '../Box/Box.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * Styles to avoid dependency cycle
 */
const StyledSelectText = styled(Combobox.Text).withConfig({
  displayName: "AtlasSelectItem__StyledSelectText",
  componentId: "sc-1r1auyo-0"
})(["&[slot='label']{font-size:", ";font-weight:", ";}&[slot='errorMessage']{font-size:", ";color:", ";}&[slot='description']{font-size:", ";color:", ";}&[slot='description']{&[aria-selected='true']{color:", ";}}"], themeGet('fontSizes.3'), themeGet('fontWeights.semibold'), themeGet('fontSizes.1'), themeGet('colors.text.danger'), themeGet('fontSizes.1'), themeGet('colors.text.subtle'), themeGet('colors.text.selected'));
/**
 * Inner visual slot to house leading visual, trailing visual, counter, and loading spinners
 */
const InnerVisualSlot = ({
  children
}) => {
  // just render a visual
  return /*#__PURE__*/React__default.createElement("span", {
    className: "combobox-item-visual"
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: 'flex',
      alignItems: 'center',
      gap: 2
    }
  }, children));
};
InnerVisualSlot.displayName = "InnerVisualSlot";
/**
 * Base component to define structure
 */
const BaseSelectItem = ({
  UNSAFE_className,
  leadingVisual: LeadingVisual,
  children,
  label,
  description,
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(Combobox.Item, _extends({
    className: UNSAFE_className
  }, props), /*#__PURE__*/React__default.createElement(InnerVisualSlot, null, typeof LeadingVisual === 'function' ? /*#__PURE__*/React__default.createElement(LeadingVisual, null) : LeadingVisual), children, label && description ? /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/React__default.createElement(StyledSelectText, {
    slot: "label"
  }, label), /*#__PURE__*/React__default.createElement(StyledSelectText, {
    slot: "description"
  }, description)) : null);
};
BaseSelectItem.displayName = "BaseSelectItem";
/**
 * Styles to avoid dependency cycle
 */
const StyledSelectItem = styled(BaseSelectItem).withConfig({
  displayName: "AtlasSelectItem__StyledSelectItem",
  componentId: "sc-1r1auyo-1"
})(["outline:none;cursor:default;color:", ";font-size:", ";position:relative;width:100%;padding:6px 12px;display:flex;align-items:center;gap:4px;&:focus{background:", ";color:", ";}&:hover{background:", ";color:", ";box-shadow:inset 2px 0px 0px ", ";}&[data-focus-visible]{background:", ";color:", ";box-shadow:inset 2px 0px 0px ", ";}&[aria-selected='true']{background-color:", ";color:", ";font-weight:", ";box-shadow:inset 2px 0px 0px ", ";&:hover{background:", ";color:", ";}&::before{alt:' ';position:absolute;top:6px;left:2px;}}&[data-pressed]{background-color:", ";color:", ";}&[aria-disabled]{background-color:", ";color:", ";cursor:not-allowed;box-shadow:inset 2px 0px 0px ", ";}@media (forced-colors:active){&:focus{background:Highlight;color:HighlightText;}}"], themeGet('colors.text.default'), themeGet('fontSize.3'), themeGet('colors.background.neutral.subtle.hovered'), themeGet('colors.text.default'), themeGet('colors.background.neutral.subtle.hovered'), themeGet('colors.text.default'), themeGet('colors.border.selected'), themeGet('colors.background.neutral.subtle.hovered'), themeGet('colors.text.default'), themeGet('colors.border.selected'), themeGet('colors.background.selected.default.[default]'), themeGet('colors.text.selected'), themeGet('fontWeight.normal'), themeGet('colors.border.selected'), themeGet('colors.background.selected.default.hovered'), themeGet('colors.text.selected'), themeGet('colors.background.neutral.subtle.pressed'), themeGet('colors.text.default'), themeGet('colors.elevation.surface.default.[default]'), themeGet('colors.text.disabled'), themeGet('colors.border.disabled'));
/**
 * The SelectItem component
 */
const AtlasSelectItem = ({
  children,
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(StyledSelectItem, props, children);
};
AtlasSelectItem.displayName = "AtlasSelectItem";

export { AtlasSelectItem, BaseSelectItem, InnerVisualSlot, StyledSelectItem, StyledSelectText };
